import { cartModel } from 'assets/components';
import { constants, chainPromises } from 'assets/utilities';

import template from './cartListTemplate';
import './cartList.scss';

const onRemoveClick = function onCartRemoveClick(ev) {
  const el = ev.currentTarget;
  const line = el.getAttribute('data-line') * 1;

  cartModel.update({
    line,
    quantity: 0,
  });
};

const onQtyChange = function onCartListQtyChange(ev) {
  const el = ev.currentTarget;
  const line = el.getAttribute('data-line') * 1;
  const quantity = el.value;

  cartModel.update({
    line,
    quantity,
  });
};

const updateQuantity = function updateCartListItemQuantity(ev, delta) {
  const el = ev.currentTarget;
  const line = el.getAttribute('data-line') * 1;
  const model = cartModel.getState().items[line - 1];

  if (!model) {
    console.error('Product data missing');
    return;
  }

  cartModel.update({
    line,
    quantity: model.quantity * 1 + delta,
  });
};

const onPlusClick = function onCartListPlusClick(ev) {
  updateQuantity(ev, 1);
};

const onMinusClick = function onCartListMinusClick(ev) {
  updateQuantity(ev, -1);
};

const onFrequencyChange = function onCartListFrequencyChange(ev) {
  const el = ev.currentTarget;
  const lines = el.getAttribute('data-lines')
    .split(',')
    .map(line => line * 1)
    .sort();

  const { items = [] } = cartModel.getState();
  const models = lines
    .map(line => ({
      ...(items[line - 1] || {}),
      line,
    }))
    .filter(item => item.id)
    .reverse();

  const removePromises = models.map(model => () => cartModel.update({
    line: model.line,
    quantity: 0,
  }, false));

  const addPromises = models.map(model => () => cartModel.add({
    id: model.id,
    properties: {
      ...model.properties,
      shipping_interval_frequency: el.value * 1,
    },
    quantity: model.quantity,
  }));

  const chainedPromises = [
    ...removePromises,
    ...addPromises,
  ];

  chainPromises(chainedPromises)
    .catch(console.error);
};

const bind = function bindCartList(props = {}) {
  const method = props.unbind ? 'removeEventListener' : 'addEventListener';

  [].forEach.call(
    document.querySelectorAll('.js-cartListQty'),
    (el) => {
      el[method]('change', onQtyChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-cartListRemove'),
    (el) => {
      el[method]('click', onRemoveClick);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-cartListFrequency'),
    (el) => {
      el[method]('change', onFrequencyChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-cartListFrequencyOption'),
    (el) => {
      el[method]('change', onFrequencyChange);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-cartListPlus'),
    (el) => {
      el[method]('click', onPlusClick);
    },
  );

  [].forEach.call(
    document.querySelectorAll('.js-cartListMinus'),
    (el) => {
      el[method]('click', onMinusClick);
    },
  );
};

const getVariants = function getCartVariants() {
  const scriptEl = document.querySelector('.js-cartData');
  const variants = JSON.parse(scriptEl.innerHTML);

  return variants;
};

const getTrailFutureItems = function getCartTrialFutureItems(items = []) {
  const variants = getVariants();

  const trialItems = items.map((item, index) => (
    {
      ...item,
      line: index + 1,
    }
  )).filter(item => (
    item.product_type === constants.cart.trialType
    && item.properties
    && item.properties.shipping_interval_frequency
  ));

  return trialItems.map((item) => {
    const pack = item.properties.trial_pack;
    const options = item.options_with_values || [];
    const colorOption = options.find(option => option.name.toLowerCase() === 'color');
    const color = colorOption ? colorOption.value : '';
    const sizeOption = options.find(option => option.name.toLowerCase() === 'size');
    const size = sizeOption ? sizeOption.value : '';
    const variant = variants.find(variantsItem => (
      variantsItem.option1 === color
      && variantsItem.option2 === size
      && variantsItem.option3 === pack
    ));

    if (!variant) {
      return item;
    }

    return {
      ...item,
      ...(variant.featured_image && variant.featured_image.src ? { image: variant.featured_image.src } : {}),
      price: variant.price,
      original_price: variant.compare_at_price || variant.price,
      product_title: variant.name.split(' -')[0],
      variant_options: item.variant_options && item.variant_options[0]
        ? [
          // Remove the backup size from info
          ...item.variant_options.slice(0, 2),
          // Add future subscription trial pack note
          item.properties && item.properties.trial_pack ? item.properties.trial_pack : null,
        ].filter(option => option)
        : [],
    };
  });
};

const render = function renderCartList(props = {}) {
  bind({ unbind: true });
  // Store Focus to restore after render
  const activeElementId = document.activeElement.getAttribute('id');

  const trialItems = getTrailFutureItems(props.items);

  document.querySelector('.js-cartList').innerHTML = template({
    ...props,
    ...(trialItems ? { trialItems } : {}),
  });

  // Restore focus
  if (document.getElementById(activeElementId)) {
    document.getElementById(activeElementId).focus();
  }
  bind();
};

const destroy = function destroyCartList() {
  bind({ unbind: true });
};

const init = function initCartList() {
  cartModel.addCallback(render);
};

export default {
  destroy,
  init,
};
